// TODO
// - create new folder for each component
export function ProductTabs(props: any) {
  return <div>ProductTabs</div>;
}

export function TouristData(props: any) {
  return <div>TouristData</div>;
}

export function InsuranceCard(props: any) {
  return <div>InsuranceCard</div>;
}

export function Footer(props: any) {
  return <div>Footer</div>;
}

export function Header(props: any) {
  return <div>Header</div>;
}

export function CheckboxCard(props: any) {
  return <div>CheckboxCard</div>;
}

export function Checkboxes(props: any) {
  return <div>Checkboxes</div>;
}

export function Carousel(props: any) {
  return <div>Carousel</div>;
}

export function Banner(props: any) {
  return <div>Banner</div>;
}
